import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";
// import 'firebase/auth'
import AuthAPI from "./network/api/AuthAPI"
import ServiceAPI from "@/network/api/ServiceAPI";
import axios from 'axios'
import { url } from "@/configs/apiUrl";
import AuditTrailAPI from "@/network/api/AuditTrailAPI";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '',
                    redirect: '/home'
                },
                {
                    path: '/login',
                    name: 'pageLogin',
                    component: () => import('@/views/auth/Login.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/logout-from-backoffice',
                    name: 'pageLogoutFromBackoffice',
                    component: () => import('@/views/auth/LogoutFromBackoffice.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                // hide register
                // {
                //     path: '/register',
                //     name: 'pageRegister',
                //     component: () => import('@/views/auth/Register.vue'),
                //     meta: {
                //         rule: 'all'
                //     }
                // },
                {
                    path: '/forgot-password',
                    name: 'pageForgotPassword',
                    component: () => import('@/views/auth/ForgotPassword.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/reset-password',
                    name: 'pageResetPassword',
                    component: () => import('@/views/auth/ResetPassword.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/callback',
                    name: 'authCallback',
                    component: () => import('@/views/auth/Callback.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/error/lock-screen',
                    name: 'pageLockScreen',
                    component: () => import('@/views/error/LockScreen.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/error/comingsoon',
                    name: 'pageComingSoon',
                    component: () => import('@/views/error/ComingSoon.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/error/availablesoon',
                    name: 'pageAvailableSoon',
                    component: () => import('@/views/error/AvailableSoon.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/error/error-404',
                    name: 'pageError404',
                    component: () => import('@/views/error/Error404.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/error/error-500',
                    name: 'pageError500',
                    component: () => import('@/views/error/Error500.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/error/maintenance',
                    name: 'pageMaintenance',
                    component: () => import('@/views/error/Maintenance.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
            ]
        },
        // =============================================================================
        // MAIN LAYOUT ROUTES
        // =============================================================================
        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: () => import('./views/account/Information.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/services',
                    name: 'myService',
                    component: () => import('./views/services/Index.vue'),
                    meta: {
                        rule: 'services'
                    }
                },
                {
                    path: '/services/payment',
                    name: 'myServicePayment',
                    // component: () => import('./views/services/Index.vue'),
                    beforeEnter: () => {
                        ServiceAPI.ListAll().then((result => {
                            AuditTrailAPI.CreateAuditTrail({
                                user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                                session_id: parseInt(localStorage.getItem('sessID')),
                                user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                                menu: result.data[1].title,
                                activity: "Redirect to " + result.data[1].title + " service",
                            }).then(() => {
                                window.location.href = result.data[1].url
                            }, () => {
                                window.location.href = result.data[1].url
                            })
                        }))
                    },
                    meta: {
                        rule: 'services'
                    }
                },
                {
                    path: '/services/tourism',
                    name: 'myServiceTourism',
                    //component: () => import('./views/services/Index.vue'),
                    beforeEnter: () => {
                        ServiceAPI.ListAll().then((result => {
                            AuditTrailAPI.CreateAuditTrail({
                                user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                                session_id: parseInt(localStorage.getItem('sessID')),
                                user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                                menu: result.data[0].title,
                                activity: "Redirect to " + result.data[0].title + " service",
                            }).then(() => {
                                window.location.href = result.data[0].url
                            }, () => {
                                window.location.href = result.data[0].url
                            })
                        }))
                    },
                    meta: {
                        rule: 'services'
                    }
                },
                {
                    path: '/services/loyalty',
                    name: 'myServiceLoyalty',
                    //component: () => import('./views/services/Index.vue'),
                    beforeEnter: () => {
                        ServiceAPI.ListAll().then((result => {
                            AuditTrailAPI.CreateAuditTrail({
                                user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                                session_id: parseInt(localStorage.getItem('sessID')),
                                user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                                menu: result.data[3].title,
                                activity: "Redirect to " + result.data[3].title + " service",
                            }).then(() => {
                                window.location.href = result.data[3].url
                            }, () => {
                                window.location.href = result.data[3].url
                            })
                        }))
                    },
                    meta: {
                        rule: 'services'
                    }
                },
                {
                    path: '/services/retail',
                    name: 'myServiceRetail',
                    beforeEnter: () => {
                        ServiceAPI.ListAll().then((result => {
                            if (result.data[2].url != "#") {
                                AuditTrailAPI.CreateAuditTrail({
                                    user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                                    session_id: parseInt(localStorage.getItem('sessID')),
                                    user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                                    menu: result.data[2].title,
                                    activity: "Redirect to " + result.data[2].title + " service",
                                }).then(() => {
                                    window.location.href = result.data[2].url
                                }, () => {
                                    window.location.href = result.data[2].url
                                })
                            }
                            window.location.href = result.data[2].url
                        }))
                    },
                    meta: {
                        rule: 'services'
                    }
                },
                {
                    path: '/services/bi',
                    name: 'myServiceBusinessInteligence',
                    //component: () => import('./views/services/Index.vue'),
                    beforeEnter: () => {
                        ServiceAPI.ListAll().then((result => {
                            AuditTrailAPI.CreateAuditTrail({
                                user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                                session_id: parseInt(localStorage.getItem('sessID')),
                                user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                                menu: result.data[4].title,
                                activity: "Redirect to " + result.data[4].title + " service",
                            }).then(() => {
                                window.location.href = result.data[4].url
                            }, () => {
                                window.location.href = result.data[4].url
                            })
                        }))
                    },
                    meta: {
                        rule: 'services'
                    }
                },
                // {
                // 	path: '/dashboard',
                // 	name: 'dashboardAnalytics',
                // 	component: () => import('./views/dashboard/Analytics.vue'),
                // 	meta: {
                // 		rule: 'editor'
                // 	}
                // },
                // Account
                {
                    path: '/account/info',
                    name: 'accountInfo',
                    component: () => import('./views/account/Information.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Account' },
                            { title: 'Information', active: true },
                        ],
                        pageTitle: 'Account Information',
                        rule: 'account_information'
                    },
                },
                {
                    path: '/account/Verification',
                    name: 'accountVerification',
                    component: () => import('./views/account/Verification.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Account' },
                            { title: 'Verification', active: true },
                        ],
                        pageTitle: 'Account Verification',
                        rule: 'merchant_verification_account'
                    },
                },
                {
                    path: '/account/update',
                    name: 'accountUpdateInfo',
                    component: () => import('./views/account/UpdateInfo.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Account' },
                            { title: 'Update information', active: true },
                        ],
                        pageTitle: 'Update Information',
                        rule: 'account_information'
                    },
                },
                {
                    path: '/account/settings',
                    name: 'accountSetting',
                    component: () => import('./views/account/Settings.vue'),
                    meta: {
                        rule: 'account_information'
                    }
                },
                {
                    path: '/merchant',
                    name: 'merchantManagement',
                    component: () => import('./views/merchant/management/Index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', active: true },
                        ],
                        pageTitle: 'Merchant Management',
                        rule: 'merchant_management'
                    }
                },
                {
                    path: '/sub-merchant',
                    name: 'subMerchantList',
                    component: () => import('./views/merchant/management/SubmerchantList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', active: true },
                        ],
                        pageTitle: 'Sub Merchant Management',
                        rule: 'merchant_management'
                    }
                },
                {
                    path: '/merchant/new',
                    name: 'merchantManagementNew',
                    component: () => import('./views/merchant/management/MerchantAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'list', url: '/merchant' },
                            { title: 'New', active: true },
                        ],
                        pageTitle: 'Add New Merchant',
                        rule: 'merchant_management'
                    }
                },
                {
                    path: '/merchant/edit/:id',
                    name: 'merchantEdit',
                    component: () => import('./views/merchant/management/MerchantEdit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', url: '/merchant' },
                            { title: 'Edit', active: true },
                        ],
                        pageTitle: 'Merchant Edit',
                        rule: 'merchant_management'
                    }
                },
                {
                    path: '/merchant/sub/new',
                    name: 'submerchantNew',
                    component: () => import('./views/merchant/management/SubmerchantAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', url: '/merchant' },
                            { title: 'New', active: true },
                        ],
                        pageTitle: 'Add New Submerchant',
                        rule: 'merchant_management'
                    }
                },
                {
                    path: '/merchant/sub/edit/:id',
                    name: 'submerchantEdit',
                    component: () => import('./views/merchant/management/SubmerchantEdit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', url: '/merchant' },
                            { title: 'Edit', active: true },
                        ],
                        pageTitle: 'Submerchant Edit',
                        rule: 'merchant_management'
                    }
                },
                {
                    path: '/merchant/configuration',
                    name: 'MerchantConfiguration',
                    component: () => import('./views/merchant/management/ConfigForm.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', active: true },
                        ],
                        pageTitle: 'Merchant Configuration',
                        rule: 'merchant_configuration'
                    }
                },
                {
                    path: '/merchant/tree',
                    name: 'treeMerchant',
                    component: () => import('./views/merchant/management/TreeMerchant.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'List', active: true },
                        ],
                        pageTitle: 'Tree Merchant',
                        rule: 'merchant_management'
                    }
                },
                // {
                // 	path: '/merchant/device/enrollment',
                // 	name: 'DeviceEnrollment',
                // 	component: () => import('./views/merchant/management/DeviceEnrollment.vue'),
                // 	props: true,
                // 	meta: {
                // 		breadcrumb: [
                // 			{ title: 'Home', url: '/home' },
                // 			{ title: 'Merchant' },
                // 			{ title: 'Device Enrollment', active: true },
                // 		],
                // 		pageTitle: 'Device Enrollment',
                // 		rule: 'editor'
                // 	}
                // },
                {
                    path: '/merchant/verification',
                    name: 'merchantVerificcation',
                    component: () => import('./views/merchant/verification/Index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'verification', active: true },
                        ],
                        pageTitle: 'Merchant Verification',
                        rule: 'merchant_verification'
                    }
                },
                {
                    path: '/merchant/verification/review/:id',
                    name: 'merchantVerificcationReview',
                    component: () => import('./views/merchant/verification/ReviewApproval.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Merchant' },
                            { title: 'verification', url: '/merchant/verification' },
                            { title: 'Review', active: true },
                        ],
                        pageTitle: 'Merchant Review',
                        rule: 'merchant_verification'
                    }
                },
                {
                    path: '/device/request',
                    name: 'requestForDevice',
                    component: () => import('./views/device/request-device/Index.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices' },
                            { title: 'Request for Devices List', active: true },
                        ],
                        pageTitle: 'Request List',
                        rule: ''
                    }
                },
                {
                    path: '/device/request/update',
                    name: 'requestForDeviceUpdate',
                    component: () => import('./views/device/request-device/EditForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices' },
                            { title: 'Request for Devices', active: true },
                        ],
                        pageTitle: 'Request for Devices',
                        rule: 'request_device'
                    }
                },
                {
                    path: '/device/request/detail',
                    name: 'requestForDeviceDetail',
                    component: () => import('./views/device/request-device/DetailForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices' },
                            { title: 'Request for Device Detail', active: true },
                        ],
                        pageTitle: 'Request for Device Detail',
                        rule: 'request_device'
                    }
                },
                {
                    path: '/device/assignment',
                    name: 'devicesAssignment',
                    component: () => import('./views/device/device-assignment/Index.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices' },
                            { title: 'Devices Assignment List', active: true },
                        ],
                        pageTitle: 'Device Assignment List',
                        rule: 'device_assignment'
                    }
                },
                {
                    path: '/device/setup',
                    name: 'deviceSetup',
                    component: () => import('./views/device/device-setup/DeviceSetup.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices' },
                            { title: 'Devices Setup List', active: true },
                        ],
                        pageTitle: 'Device Setup List',
                        rule: 'device_assignment'
                    }
                },
                {
                    path: '/device/setup-detail',
                    name: 'deviceSetupDetail',
                    component: () => import('./views/device/device-setup/DeviceSetupDetail.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device' },
                            { title: 'Device Setup Detail', active: true },
                        ],
                        pageTitle: 'Device Setup Detail',
                        rule: 'device_assignment'
                    }
                },
                {
                    path: '/device/setup-configuration',
                    name: 'deviceSetupConfiguration',
                    component: () => import('./views/device/device-setup/DeviceSetupConfiguration.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device' },
                            { title: 'Device Setup Configuration', active: true },
                        ],
                        pageTitle: 'Device Setup Configuration',
                        rule: 'device_assignment'
                    }
                },
                {
                    path: '/device/assignment/update',
                    name: 'deviceAssignmentUpdate',
                    component: () => import('./views/device/device-assignment/EditForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices Assignment' },
                            { title: 'Devices Assignment', active: true },
                        ],
                        pageTitle: 'Devices Assignment',
                        rule: 'device_assignment'
                    }
                },
                {
                    path: '/device/assignment/detail',
                    name: 'deviceAssignmentDetail',
                    component: () => import('./views/device/device-assignment/DetailForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Devices Assignment' },
                            { title: 'Devices Assignment Detail', active: true },
                        ],
                        pageTitle: 'Devices Assignment Detail',
                        rule: 'device_assignment'
                    }
                },
                {
                    path: '/device/type',
                    name: 'DeviceTypeList',
                    component: () => import('./views/device/device-type/DeviceTypeList.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Type List', active: true },
                        ],
                        pageTitle: 'Device Type List',
                        rule: 'device_type'
                    }
                },
                {
                    path: '/device/type/add',
                    name: 'deviceType',
                    component: () => import('./views/device/device-type/DeviceType.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Type List', url: '/device/type' },
                            { title: 'Add Device Type', active: true },
                        ],
                        pageTitle: 'Add Device Type',
                        rule: 'device_type'
                    }
                },
                {
                    path: '/device/type/edit',
                    name: 'deviceTypeEdit',
                    component: () => import('./views/device/device-type/DeviceType.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Type List', url: '/device/type' },
                            { title: 'Update Device Type', active: true },
                        ],
                        pageTitle: 'Update Device Type',
                        rule: 'device_type'
                    }
                },
                {
                    path: '/device/list',
                    name: 'DeviceList',
                    component: () => import('./views/device/device-registration/DeviceList.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device List', active: true },
                        ],
                        pageTitle: 'Device List',
                        rule: 'device_registration'
                    }
                },
                {
                    path: '/device/add',
                    name: 'DeviceRegistration',
                    component: () => import('./views/device/device-registration/DeviceRegistration.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device List', url: '/device/list' },
                            { title: 'Add Device', active: true },
                        ],
                        pageTitle: 'Add Device',
                        rule: 'device_registration'
                    }
                },
                {
                    path: '/device/edit/:id/:current_device_data',
                    name: 'DeviceEdit',
                    component: () => import('./views/device/device-registration/DeviceRegistration.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device List', url: '/device/list' },
                            { title: 'Edit Device', active: true },
                        ],
                        pageTitle: 'Edit Device',
                        rule: 'device_registration'
                    }
                },
                {
                    path: '/device/report',
                    name: 'DeviceReport',
                    component: () => import('./views/device/device-report/DeviceReportList.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Report', active: true },
                        ],
                        pageTitle: 'Device Report',
                        rule: 'device_report'
                    }
                },
                {
                    path: '/device/config',
                    name: 'DeviceConfig',
                    component: () => import('./views/device/device-report/DeviceConfig.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Report', url: '/device/report' },
                            { title: 'Device Configuration', active: true },
                        ],
                        pageTitle: 'Device Configuration',
                        rule: 'device_report'
                    }
                },
                {
                    path: '/device/bulk',
                    name: 'DeviceImportExcel',
                    component: () => import('./views/device/device-registration/DeviceImportExcel.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Bulk', active: true },
                        ],
                        pageTitle: 'Bulk Device Registration',
                        rule: 'device_registration'
                    }
                },
                {
                    path: '/dashboard/device-monitoring',
                    name: 'DeviceMonitoringDashboard',
                    component: () => import('./views/device/device-monitoring-dashboard/DeviceMonitoringDashboard.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Dashboard Device Monitoring', active: true },
                        ],
                        pageTitle: 'Dashboard Device Monitoring',
                        rule: 'device_monitoring'
                    }
                },
                {
                    path: '/dashboard/transaction-summary',
                    name: 'DeviceMonitoringDashboard',
                    component: () => import('./views/device/dashboard-trans-summary/DashboardTransSummary.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Dashboard Transaction Summary', active: true },
                        ],
                        pageTitle: 'Dashboard Transaction Summary',
                        rule: 'device_trans_summary'
                    }
                },
                {
                    path: '/device/monitoring',
                    name: 'DeviceMonitoring',
                    component: () => import('./views/device/device-monitoring/DeviceMonitoring.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Monitoring', active: true },
                        ],
                        pageTitle: 'Device Monitoring',
                        rule: 'device_monitoring'
                    }
                },
                {
                    path: '/device/monitoring/detail',
                    name: 'DeviceMonitoringDetail',
                    component: () => import('./views/device/device-monitoring/DeviceMonitoringDetail.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Monitoring', url: '/device/monitoring' },
                            { title: 'Device Monitoring Detail', active: true },
                        ],
                        pageTitle: 'Detail Device Monitoring',
                        rule: 'device_monitoring'
                    }
                },
                {
                    path: '/device/activity/log',
                    name: 'DeviceActivityLog',
                    component: () => import('./views/device/activity/log.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Monitoring', url: '/device/monitoring' },
                            { title: 'Device Activity Log', active: true },
                        ],
                        pageTitle: 'Device Activity Log',
                        rule: 'root_admin'
                    }
                },
                {
                    path: '/device/transaction/summaries',
                    name: 'DeviceTransactionSummaries',
                    component: () => import('./views/device/device-transaction-summary/DeviceTransactionSummary.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Transaction Summaries', active: true },
                        ],
                        pageTitle: 'Device Transaction Summaries',
                        rule: 'device_trans_summary'
                    }
                },
                {
                    path: '/device/transaction/summary',
                    name: 'DeviceTransactionSummaryDetails',
                    component: () => import('./views/device/device-transaction-summary/DeviceTransactionSummaryDetails.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Transaction Summaries', url: '/device/transaction/summaries' },
                            { title: 'Details', active: true },
                        ],
                        pageTitle: 'Device Transaction Summaries',
                        rule: 'device_trans_summary'
                    }
                },
                {
                    path: '/device/event',
                    name: 'DeviceEvent',
                    component: () => import('./views/device/device-event/DeviceEvent.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Event', active: true },
                        ],
                        pageTitle: 'Device Event',
                        rule: 'all_aino'
                    }
                },
                {
                    path: '/device/update',
                    name: 'DeviceUpdate',
                    component: () => import('./views/device/device-update/DeviceUpdate.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Update', active: true },
                        ],
                        pageTitle: 'Device Update',
                        rule: 'all_internal_aino'
                    }
                },
                {
                    path: '/device/mapping',
                    name: 'DeviceMapping',
                    component: () => import('./views/device/device-mapping/DeviceMappingList.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Mapping', active: true },
                        ],
                        pageTitle: 'Device Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/device/mapping/add',
                    name: 'AddDeviceMapping',
                    component: () => import('./views/device/device-mapping/AddDeviceMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Mapping', url: '/device/mapping' },
                            { title: 'Add Device Mapping', active: true },
                        ],
                        pageTitle: 'Add Device Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/device/mapping/edit',
                    name: 'EditDeviceMapping',
                    component: () => import('./views/device/device-mapping/EditDeviceMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Edit Device Mapping', active: true },
                        ],
                        pageTitle: 'Edit Device Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/location-mapping',
                    name: 'LocationMapping',
                    component: () => import('./views/merchant/location-mapping/LocationMappingList.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Location Mapping', active: true },
                        ],
                        pageTitle: 'Location Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/location-mapping/add',
                    name: 'AddLocationMapping',
                    component: () => import('./views/merchant/location-mapping/AddLocationMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Add Location Mapping', active: true },
                        ],
                        pageTitle: 'Add Location Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/location-mapping/edit',
                    name: 'EditLocationMapping',
                    component: () => import('./views/merchant/location-mapping/EditLocationMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Edit Location Mapping', active: true },
                        ],
                        pageTitle: 'Edit Location Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/svd-location-mapping',
                    name: 'SVDLocationMapping',
                    component: () => import('./views/merchant/svd-location-mapping/SVDLocationMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'SVD Location Mapping', active: true },
                        ],
                        pageTitle: 'SVD Location Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/svd-location-mapping/add',
                    name: 'AddSVDLocationMapping',
                    component: () => import('./views/merchant/svd-location-mapping/AddSVDLocationMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Add SVD Location Mapping', active: true },
                        ],
                        pageTitle: 'SVD Add Location Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/svd-location-mapping/edit',
                    name: 'EditSVDLocationMapping',
                    component: () => import('./views/merchant/svd-location-mapping/EditSVDLocationMapping.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Edit SVD Location Mapping', active: true },
                        ],
                        pageTitle: 'Edit SVD Location Mapping',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/tid-and-mid-management',
                    name: 'TIDAndMIDManagement',
                    component: () => import('./views/merchant/tid-and-mid/ListTIDAndMid.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'MID & TID Management', active: true },
                        ],
                        pageTitle: 'MID & TID Management',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/tid-and-mid-management/mid/add',
                    name: 'MIDAdd',
                    component: () => import('./views/merchant/tid-and-mid/AddMid.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'TID & MID List', url: '/tid-and-mid-management' },
                            { title: 'Add MID', active: true },
                        ],
                        pageTitle: 'Add MID',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/tid-and-mid-management/tid/add',
                    name: 'TIDAdd',
                    component: () => import('./views/merchant/tid-and-mid/AddTid.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'TID & MID List', url: '/tid-and-mid-management' },
                            { title: 'Add TID', active: true },
                        ],
                        pageTitle: 'Add TID',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/tid-and-mid-management/mid/edit',
                    name: 'Editmid',
                    component: () => import('./views/merchant/tid-and-mid/EditMid.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'TID & MID List', url: '/tid-and-mid-management' },
                            { title: 'Edit MID', active: true },
                        ],
                        pageTitle: 'Edit MID',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/tid-and-mid-management/tid/edit',
                    name: 'EditTid',
                    component: () => import('./views/merchant/tid-and-mid/EditTid.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'TID & MID List', url: '/tid-and-mid-management' },
                            { title: 'Edit TID', active: true },
                        ],
                        pageTitle: 'Edit TID',
                        rule: 'device_and_location_mapping'
                    }
                },
                {
                    path: '/device/request-devices',
                    name: 'DeviceRequest',
                    component: () => import('./views/device/device-request/DeviceRequest.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Request', active: true },
                        ],
                        pageTitle: 'Device Request',
                        rule: 'all_internal_aino'
                    }
                },
                {
                    path: '/device/request-devices/add',
                    name: 'DeviceRequestAdd',
                    component: () => import('./views/device/device-request/DeviceRequestAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Request', url: '/device/request-devices' },
                            { title: 'Add Device Request', active: true },
                        ],
                        pageTitle: 'Add Device Request',
                        rule: 'all_internal_aino'
                    }
                },
                {
                    path: '/device/request-devices/:id',
                    name: 'DeviceRequestShow',
                    component: () => import('./views/device/device-request/DeviceRequestAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Device Request', url: '/device/request-devices' },
                            { title: 'Edit Device Request', active: true },
                        ],
                        pageTitle: 'Edit Device Request',
                        rule: 'all_internal_aino'
                    }
                },
                {
                    path: '/users',
                    name: 'UsersIndex',
                    component: () => import('./views/users/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Users', active: true },
                        ],
                        pageTitle: 'Users',
                        rule: 'user_management'
                    }
                },
                {
                    path: '/users/add',
                    name: 'UsersAdd',
                    component: () => import('./views/users/add.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Users', url: '/users' },
                            { title: 'Add', active: true },
                        ],
                        pageTitle: 'Add User',
                        rule: 'user_management'
                    }
                },
                {
                    path: '/users/edit',
                    name: 'UsersEdit',
                    component: () => import('./views/users/edit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Users', url: '/users' },
                            { title: 'Edit', active: true },
                        ],
                        pageTitle: 'Edit User Data',
                        rule: 'user_management'
                    }
                },
                {
                    path: '/users/configure',
                    name: 'UsersConfigure',
                    component: () => import('./views/users/configure.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Users', url: '/users' },
                            { title: 'Configure', active: true },
                        ],
                        pageTitle: 'Configure User',
                        rule: 'user_management'
                    }
                },
                {
                    path: '/shiftdate',
                    name: 'ShiftdateMapping',
                    component: () => import('./views/shiftdate/shiftdate.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Shiftdate Mapping', active: true },
                        ],
                        pageTitle: 'Shiftdate Mapping',
                        rule: 'shiftdate_mapping'
                    }
                },
                {
                    path: '/audit-trail/list',
                    name: 'AuditTrail',
                    component: () => import('./views/audit-trail/index.vue'),
                    props: true,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/home' },
                            { title: 'Audit Trail', active: true },
                        ],
                        pageTitle: 'Audit Trail',
                        rule: 'all_aino'
                    }
                },
            ],
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/error/error-404'
        }
    ],
})

router.afterEach(() => {
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
    if (auth.isAuthenticated() && to.path !== '/login') {
        //validate session
        try {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            axios.post(url.svd.auth.validatesession, {}, { headers: { 'Authorization': `Bearer ${userInfo.access_token.token}` } }).then(resp => {
                if (resp.data.message_code !== "VALID_SESSION") {
                    localStorage.clear();
                    router.push('/login')
                } else {
                    if (localStorage.getItem('sessID' === null)) {
                        localStorage.setItem('sessID', resp.data.data.id)
                    }

                    if (localStorage.getItem('sessID') != resp.data.data.id) {
                        localStorage.setItem('sessID', resp.data.data.id)
                    }
                    let isChange = false
                    let role = localStorage.getItem('userRole')
                    if (role !== undefined && (role !== "root" ||
                        role !== "administrator" ||
                        role !== "issuer_user" ||
                        role !== "aino_finance" ||
                        role !== "aino_cc" ||
                        role !== "aino_recon" ||
                        role !== "aino_recon_child" ||
                        role !== "aino_pios" ||
                        role !== "customer_service")) {
                        AuthAPI.UserInfo(null).then((result) => {
                            if (result.data !== null) {
                                for (let merchant of result.data.merchant) {
                                    if (merchant.parent_id === 0) {
                                        if (merchant.status === "active") {
                                            if (role !== result.data.roles[0]) {
                                                isChange = true
                                            }

                                            role = result.data.roles[0]
                                        } else {
                                            if (role !== "unverified_merchant") {
                                                isChange = true
                                            }

                                            role = "unverified_merchant"
                                        }

                                        localStorage.setItem('userRole', role);
                                        if (isChange) {
                                            window.location.reload()
                                        }
                                    }
                                }
                            }
                        })
                    }
                }
            }).catch(e => {
                console.log("Error while validating session")
                console.log(e)
                localStorage.clear();
                router.push('/login')
            })
        } catch (e) {
            console.log("Error while validating session")
            console.log(e)
            localStorage.clear();
            router.push('/login')
        }
    }

    if ((to.path === "/login" || to.path === "/register") && auth.isAuthenticated()) {
        let isContinueRedirect = (to.query.continue === undefined) ? false : true
        //validate session
        try {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            axios.post(url.svd.auth.validatesession, {}, { headers: { 'Authorization': `Bearer ${userInfo.access_token.token}` } }).then(resp => {
                if (resp.data.message_code !== "VALID_SESSION") {
                    localStorage.clear();
                    if (isContinueRedirect) return next()
                    else router.push('/login')
                } else {
                    if (isContinueRedirect) return next()
                    else router.push({ path: '/home' })
                }
            }).catch(e => {
                console.log("Error while validating session")
                console.log(e)
                localStorage.clear();
                if (isContinueRedirect) return next()
                else router.push('/login')
            })

        } catch (e) {
            console.log("Error while validating session")
            console.log(e)
            localStorage.clear();
            if (isContinueRedirect) return next()
            else router.push('/login')
        }
    }

    if (
        to.path === "/login" ||
        to.path === "/forgot-password" ||
        to.path === "/register" ||
        to.path === "/callback" ||
        to.path === "/error/comingsoon" ||
        to.path === "/error/error-404" ||
        to.path === "/error/error-500" ||
        (auth.isAuthenticated())
    ) {
        let uRole = localStorage.getItem("userRole");
        if (to.path === '/home' && (uRole === 'root' || uRole === 'administrator' || uRole === 'aino_finance' || uRole === 'aino_recon' || uRole === 'aino_recon_child' || uRole === 'aino_cc')) {
            router.push('/merchant')
        } else if (to.path === '/home' && (uRole === 'issuer_user' || uRole === 'aino_pios' || uRole === 'customer_service')) {
            router.push('/services')
        }
        return next();
    }
    router.push({ path: '/login', query: { to: to.path } })
})

export default router